import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore, enableIndexedDbPersistence } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDtFsw9LzF6lDjBUHXcYUuDQp03U3BE5FA",
  authDomain: "studyos-dee07.firebaseapp.com",
  projectId: "studyos-dee07",
  storageBucket: "studyos-dee07.firebasestorage.app",
  messagingSenderId: "822293897107",
  appId: "1:822293897107:web:db72067584d4f68f069266",
  measurementId: "G-H2RRVR8CEP"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const googleProvider = new GoogleAuthProvider();

enableIndexedDbPersistence(db).catch((err) => {
  console.warn("Offline persistence:", err.code);
});

export default app;